// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-name[data-v-5faea506] {\n    font: normal 14px/30px Roboto;\n    letter-spacing: 0px;\n    color: #8292A5;\n}\n\n", ""]);
// Exports
module.exports = exports;
